var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 103,
    viewBox: "0 0 150 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.216 7.62354C123.069 12.6797 130.489 30.8057 128.954 47.1191C127.333 63.5279 116.759 78.1241 104.905 88.4273C93.0514 98.6351 80.0038 104.55 69.941 101.211C59.7929 97.8719 52.7148 85.3745 40.9464 75.1667C29.178 64.8635 12.8046 56.9453 10.8432 46.7375C8.88178 36.5297 21.2471 24.1277 33.0155 19.0715C44.7839 14.0153 55.8701 16.4003 69.5146 13.5383C83.1591 10.6763 99.362 2.56734 111.216 7.62354Z",
    fill: "#FFF0D4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.1357,
    cy: 54.2764,
    rx: 24.8936,
    ry: 24.8935,
    fill: "url(#paint0_linear_15140_11276)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6922 66.2704C72.8533 66.2704 72.0145 65.9566 71.3742 65.3251L62.4879 56.5625C61.2072 55.2996 61.2072 53.2539 62.4879 51.9947C63.7686 50.7318 65.8394 50.7281 67.1201 51.991L73.6922 58.4716L89.1504 43.2284C90.4311 41.9655 92.5019 41.9655 93.7826 43.2284C95.0633 44.4913 95.0633 46.537 93.7826 47.7999L76.0101 65.3251C75.3698 65.9566 74.531 66.2704 73.6922 66.2704Z",
    fill: "#FCFCFC",
    stroke: "#FDB426",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9023 54.7578V58.1151",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5881 56.4355H9.21875",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.875 25.9922V29.3495",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.561 27.668H145.191",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0117 0V3.35732",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6975 1.67578H76.3281",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5508 92.3555V95.7128",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2366 94.0312H20.8672",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.365 13.8877C134.366 14.4373 134.203 14.9749 133.897 15.4322C133.591 15.8896 133.156 16.2463 132.647 16.4571C132.137 16.668 131.577 16.7236 131.036 16.6168C130.495 16.51 129.997 16.2457 129.607 15.8573C129.217 15.4689 128.951 14.9739 128.843 14.4349C128.735 13.8959 128.79 13.3371 129.001 12.8292C129.212 12.3213 129.569 11.8872 130.028 11.5818C130.486 11.2763 131.026 11.1133 131.577 11.1133C132.316 11.1133 133.025 11.4055 133.547 11.9257C134.07 12.4459 134.364 13.1515 134.365 13.8877Z",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14104 80.5472C6.56176 79.9608 7.23643 78.3378 6.64794 76.9222C6.05946 75.5066 4.43067 74.8343 3.00995 75.4207C1.58923 76.0071 0.914562 77.63 1.50305 79.0457C2.09153 80.4613 3.72031 81.1335 5.14104 80.5472Z",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.029 42.2766C137.035 42.3634 137.024 42.4508 136.995 42.5331C136.967 42.6154 136.921 42.6908 136.862 42.7548C136.802 42.8187 136.73 42.8698 136.65 42.9046C136.57 42.9395 136.484 42.9576 136.396 42.9576C136.309 42.9576 136.222 42.9395 136.142 42.9046C136.062 42.8698 135.99 42.8187 135.93 42.7548C135.871 42.6908 135.826 42.6154 135.797 42.5331C135.768 42.4508 135.757 42.3634 135.764 42.2766C135.776 42.1179 135.848 41.9697 135.965 41.8615C136.082 41.7534 136.236 41.6934 136.396 41.6934C136.556 41.6934 136.71 41.7534 136.827 41.8615C136.944 41.9697 137.016 42.1179 137.029 42.2766Z",
    stroke: "#FDB426",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.417 83.1908C120.418 83.316 120.381 83.4386 120.312 83.543C120.243 83.6475 120.144 83.7291 120.028 83.7775C119.912 83.8259 119.785 83.839 119.661 83.815C119.538 83.7911 119.425 83.7312 119.336 83.6429C119.246 83.5547 119.186 83.442 119.161 83.3193C119.136 83.1966 119.148 83.0693 119.196 82.9536C119.244 82.8379 119.326 82.7389 119.43 82.6693C119.534 82.5997 119.657 82.5625 119.783 82.5625C119.95 82.5625 120.111 82.6286 120.23 82.7463C120.349 82.864 120.416 83.0238 120.417 83.1908V83.1908Z",
    stroke: "#AB7A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15140_11276",
    x1: 78.1357,
    y1: 29.3828,
    x2: 78.1357,
    y2: 79.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FFB931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.dc3f69ee29fa9a88fcb02c890be4c5ec.svg";
export { ForwardRef as ReactComponent };